import React from 'react';

interface TypingIndicatorProps {
  elapsed: number;
}

const TypingIndicator: React.FC<TypingIndicatorProps> = ({ elapsed }) => {
  const seconds = Math.floor(elapsed / 1000);

  let text: string;
  if (seconds < 5) {
    text = '';
  } else if (seconds < 15) {
    text = 'AI анализирует...';
  } else if (seconds < 30) {
    text = 'Анализирую контекст проблемы...';
  } else {
    text = 'Формирую уточняющие вопросы...';
  }

  return (
    <div
      className="flex items-center gap-2" style={{ padding: 'var(--space-3) var(--space-4)', borderLeft: '3px solid var(--primary-200)' }}
      role="status"
      aria-live="assertive"
      aria-label="Агент печатает"
    >
      <div className="flex gap-1">
        {[0, 1, 2].map(i => (
          <span
            key={i}
            style={{
              width: 6,
              height: 6,
              borderRadius: '50%',
              background: 'var(--gray-400)',
              animation: 'supportChatDotPulse 1.4s infinite',
              animationDelay: `${i * 0.2}s`,
            }}
          />
        ))}
      </div>
      {text && (
        <span className="text-xs-gray-500">
          {text}
        </span>
      )}
    </div>
  );
};

export default TypingIndicator;
